import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ClerkApiInitializer from './ClerkApiInitializer';
import reportWebVitals from './reportWebVitals';
import { ClerkProvider } from "@clerk/react";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
   {/*<React.StrictMode>*/}
    <ClerkProvider
      publishableKey={process.env.REACT_APP_CLERK_PUBLISHABLE_KEY}
      afterSignOutUrl="/"
      allowedRedirectOrigins={['https://krast.keywordsstudios.com']}
      localization={{
        formFieldAction__forgotPassword: 'Change password?'
      }}
    >
      <App />
      <ClerkApiInitializer />
    </ClerkProvider>
    {/*</React.StrictMode>*/}
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
